document.addEventListener("DOMContentLoaded", () => {
  let loading = false;
  let nextPageUrl = document.querySelector('link[rel="next"]')?.href;

  const createLoader = () => {
    if (!document.getElementById("infinite-loader")) {
      const loader = document.createElement("div");
      loader.id = "infinite-loader";

      loader.innerHTML = `
        <div class="infinite-spinner"></div>
      `;

      document.querySelector("#product-grid")?.after(loader);
    }
  };

  createLoader();

  const loadMoreProducts = async () => {
    if (loading || !nextPageUrl) return;

    loading = true;

    const loader = document.getElementById("infinite-loader");
    if (loader) loader.style.display = "flex";

    try {
      const response = await fetch(nextPageUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const currentGrid = document.querySelector("#product-grid");
      const newGrid = doc.querySelector("#product-grid");

      if (currentGrid && newGrid) {
        currentGrid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      }

      nextPageUrl = doc.querySelector('link[rel="next"]')?.href || null;

      if (!nextPageUrl && loader) {
        loader.style.display = "none";
      }
    } catch (error) {
      console.error("Infinite Scroll Error:", error);
    }

    if (loader && nextPageUrl) {
      loader.style.display = "none";
    }

    loading = false;
  };

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 800
    ) {
      loadMoreProducts();
    }
  };

  window.addEventListener("scroll", handleScroll);
});